import { apiEndpoints } from 'shared/model/apiEndpoints'

import { globalAPI } from 'shared/config/redux/api/global'
import { GET_TABLE_DATA, GET_USER } from 'shared/config/redux/constants/tags'

import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  ChangeUserRequest,
  ChangeUserResponse,
  CreateUserResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  RolesResponse,
  UserInfoFormState,
  UserParams,
  UserResponse,
} from '../types'

export const accessManageApi = globalAPI.injectEndpoints({
  endpoints: (build) => ({
    getUserRoles: build.query<RolesResponse, void>({
      query: () => ({
        url: apiEndpoints.roles,
      }),
    }),
    getUser: build.query<UserResponse, { params: UserParams }>({
      query: ({ params }) => ({
        url: `${apiEndpoints.users}${params.id}/`,
      }),
      providesTags: [GET_USER],
    }),
    updateUser: build.mutation<ChangeUserResponse, ChangeUserRequest>({
      query: ({ params, ...body }) => ({
        method: 'PATCH',
        url: `${apiEndpoints.users}${params.id}/update/`,
        body,
      }),
      invalidatesTags: [GET_USER, GET_TABLE_DATA],
    }),
    changePassword: build.mutation<
      ChangePasswordResponse,
      ChangePasswordRequest
    >({
      query: ({ params, ...body }) => ({
        method: 'POST',
        url: `${apiEndpoints.users}${params.id}/changePassword/`,
        body,
      }),
    }),
    createUser: build.mutation<CreateUserResponse, UserInfoFormState>({
      query: (body) => ({
        method: 'POST',
        url: apiEndpoints.createUser,
        body,
      }),
      invalidatesTags: [GET_TABLE_DATA],
    }),
    resetPassword: build.mutation<ResetPasswordResponse, ResetPasswordRequest>({
      query: ({ params, ...body }) => ({
        method: 'POST',
        url: `${apiEndpoints.users}${params.id}/resetPassword/`,
        body,
      }),
    }),
  }),
})

export const {
  useGetUserRolesQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useChangePasswordMutation,
  useCreateUserMutation,
  useResetPasswordMutation,
} = accessManageApi
